import type { AppFeatures } from '@/modules/config';

/** Whether the beta-testing gate is on, per the feature flag. */
export function betaTestingEnabled(features: AppFeatures): boolean {
  return features.betaTesting === true;
}

// Route the beta create-action toast sends non-beta users to, so they can tell
// us about the action they had in mind.
const BETA_CONTACT_ROUTE = '/contact';

// Toast copy shown when a non-beta user taps the (enabled) create-action button
// while the betaTesting gate is on. `[Contact]` is the toast-button label.
const BETA_CREATE_ACTION_TOAST_HELP =
  'You currently need to be a beta-tester to add topics. But shoot us a note with what you had in mind! [Contact]';

/**
 * The `onDemandConsolation` for the create-action ActionGuard while the
 * betaTesting gate is on, or `undefined` when off. When on, a non-beta user (who
 * has no verification path to create topics) gets an enabled button that toasts
 * an invitation to the contact page instead of a hidden button. When off, this
 * returns `undefined` and the button behaves exactly as it did before. The
 * `[message, route]` tuple gives the toast a `[Contact]` button to the contact
 * page.
 */
export function betaCreateTopicConsolation(
  features: AppFeatures
): [message: string, route: string] | undefined {
  return betaTestingEnabled(features)
    ? [BETA_CREATE_ACTION_TOAST_HELP, BETA_CONTACT_ROUTE]
    : undefined;
}
